/**
 * toggleSidebar
 * - sets the class 'is-animated' on the body, this is done to avoid the animation of the initial state of the sidebar, set in loadSidebar.
 * - creates the on click listener for '.js-toggle-sidebar'.
 *
 * The on click listener for '.js-toggle-sidebar' toggles the class 'is-sidebar-open' on the 'body' element and the state of the sidebar in localStorage.
 *
 * Related:
 * - loadSidebar.js included in onload.js
 */

// de sub sidebar met de filters zit onder de aside. dat blauwe randje bij de aside gaat over de pijl van de sub heen waardoor je er niet op kan klikken
function asideItems() {
	const sidebarIsOpenClass = 'is-sidebar-open';
	const subSidebarIsOpenClass = 'is-sub-sidebar-open';
	const localStorageKeySidebar = 'isSidebarOpen';
	const localStorageKeySubSidebar = 'isSubSidebarOpen';

	const filterIcon = '.js-toggle-sub-sidebar span i';
	const filterIconClosed = 'fa-filter';
	const filterIconOpen = 'fa-times';

	document.body.classList.add('is-animated');

	$(document).on('click', '.js-toggle-sidebar', () => {
		if (document.body.classList.contains(sidebarIsOpenClass)) {
			document.body.classList.remove(sidebarIsOpenClass);
			localStorage.removeItem(localStorageKeySidebar);
		} else {
			document.body.classList.add(sidebarIsOpenClass);
			localStorage.setItem(localStorageKeySidebar, true);
		}
	});

	$(document).on('click', '.js-toggle-sub-sidebar', () => {
		if (document.body.classList.contains(subSidebarIsOpenClass)) {
			document.body.classList.remove(subSidebarIsOpenClass);

			$(filterIcon).addClass(filterIconClosed);
			$(filterIcon).removeClass(filterIconOpen);

			$('.js-resize').removeClass('is-7');
			$('.js-resize').addClass('is-10');

			localStorage.removeItem(localStorageKeySubSidebar);
		} else {
			$(filterIcon).addClass(filterIconOpen);
			$(filterIcon).removeClass(filterIconClosed);

			$('.js-resize').removeClass('is-10');
			$('.js-resize').addClass('is-7');

			document.body.classList.add(subSidebarIsOpenClass);
			localStorage.setItem(localStorageKeySubSidebar, true);
		}
	});

	$(document).on('click', '.js-close-filter-menu', () => {
		// localStorage.removeItem(localStorageKeySubSidebar);

		$('.js-filter-item-header').each(function (i, el) {
			if ($(this).is(':visible')) {
				$(this)
					.next('.input-container')
					.hide('fast');
				$(this)
					.find('span')
					.toggleClass('active');
			}
		});
	});

	$(document).on('click', '.js-filter-item-header', function () {
		$(this)
			.find('span')
			.toggleClass('active');
		$(this)
			.next('.input-container')
			.slideToggle('fast');
		$(this).parent()
			.find('.tags.has-addons')
			.slideToggle('fast');
	});
}
asideItems();
